import { Injectable, inject } from '@angular/core';
import imageCompression from 'browser-image-compression';
import { RegistrationApi } from '../data-access/registration-api.service';

@Injectable({ providedIn: 'root' })
export class RegistrationImages {
  private readonly api = inject(RegistrationApi);
  /** Prepare before registration: the server-issued upload credential lasts only 10 seconds. */
  async prepare(files: readonly (File | null | undefined)[]): Promise<Array<{ index: number; file: File }>> {
    return Promise.all(files.flatMap((file, i) => file ? [this.compress(file).then(result => ({ index: i + 1, file: result }))] : []));
  }
  private async compress(file: File): Promise<File> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 30000);
    try {
      const blob = await imageCompression(file, { maxSizeMB: 0.8, maxWidthOrHeight: 800, signal: controller.signal });
      return new File([blob], file.name, { type: blob.type });
    } finally { clearTimeout(timer); }
  }
  async upload(memberId: number, key: string | undefined, files: readonly { index: number; file: File }[]): Promise<boolean> {
    if (!files.length) return true;
    if (!key) return false;
    const results = await Promise.allSettled(files.map(file => this.api.upload(memberId, file.index, key, file.file)));
    return results.every(result => result.status === 'fulfilled');
  }
}
